import { ConfigEnvironment } from './configTypes';

export const environment = (window as any).SQUPRELEASEVARS?.Environment;

export const isProd = ['Production', 'ProductionEU', 'ProductionUK', 'ProductionAU'].includes(environment);

export const isTestEnvironment = (window as any).Cypress || false;

const PER_BRANCH_ENVIRONMENTS: readonly string[] = [
    'Local',
    'Development',
    'EUDevelopment'
] satisfies ConfigEnvironment[];

/**
 * Whether every branch deploys to its own `<stage>.<domain>` host in this environment, so the first
 * hostname label is the deployment stage, not a tenant subdomain, and the app a user sees is their
 * branch's rather than the tenant's stage.
 */
export const isPerBranchEnvironment = (configEnvironment: string | undefined): boolean =>
    PER_BRANCH_ENVIRONMENTS.includes(configEnvironment ?? '');
